/**
 * 24時間形式（HH:mm）をam/pm形式に変換
 */
export function convert24To12(time24: string): { hour: number; isAm: boolean } {
    const [hours] = time24.split(':').map(Number);
    if (hours === 0) {
        return { hour: 12, isAm: true };
    } else if (hours === 12) {
        return { hour: 12, isAm: false };
    } else if (hours < 12) {
        return { hour: hours, isAm: true };
    } else {
        return { hour: hours - 12, isAm: false };
    }
}

/**
 * am/pm形式を24時間形式（HH:mm）に変換
 */
export function convert12To24(hour12: number, isAm: boolean): string {
    let hour24: number;
    if (hour12 === 12) {
        hour24 = isAm ? 0 : 12;
    } else {
        hour24 = isAm ? hour12 : hour12 + 12;
    }
    return `${hour24.toString().padStart(2, '0')}:00`;
}

/**
 * HH:mm 形式バリデーション正規表現
 */
export const TIME_FORMAT_REGEX = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
